import React from 'react';
import { Sun, Moon, Monitor } from 'lucide-react';
import { Card, CardContent, CardHeader } from '../../components/ui';
import { cn } from '@/lib/utils';
import { useThemeStore, type ThemeMode } from '../../store/theme';

const THEME_OPTIONS: { value: ThemeMode; label: string; description: string; Icon: typeof Sun }[] = [
  { value: 'light', label: 'Light', description: 'Light background', Icon: Sun },
  { value: 'dark', label: 'Dark', description: 'Dark background', Icon: Moon },
  { value: 'system', label: 'System', description: 'Match device setting', Icon: Monitor },
];

export function SettingsAppearanceSection() {
  const { theme, setTheme } = useThemeStore();

  return (
    <Card className="mb-6">
      <CardHeader>
        <h2 className="text-xl font-semibold text-foreground">Appearance</h2>
        <p className="text-muted-foreground">Choose how CourtSync looks on this device</p>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col sm:flex-row gap-2" role="radiogroup" aria-label="Color theme">
          {THEME_OPTIONS.map(({ value, label, description, Icon }) => {
            const selected = theme === value;
            return (
              <button
                key={value}
                type="button"
                role="radio"
                aria-checked={selected}
                onClick={() => setTheme(value)}
                className={cn(
                  'flex flex-1 items-center gap-3 rounded-lg border px-4 py-3 text-left transition-colors',
                  selected
                    ? 'border-primary-500 bg-primary-50 ring-2 ring-primary-500/20 ring-offset-2 ring-offset-background dark:border-primary-400 dark:bg-primary-500/10 dark:ring-primary-400/30'
                    : 'border-border bg-card hover:bg-muted/50'
                )}
              >
                <Icon
                  className={cn(
                    'h-5 w-5 shrink-0',
                    selected ? 'text-primary-600 dark:text-primary-400' : 'text-muted-foreground'
                  )}
                  aria-hidden
                />
                <span>
                  <span className="block text-sm font-medium text-foreground">{label}</span>
                  <span className="block text-xs text-muted-foreground">{description}</span>
                </span>
              </button>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
